import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { Type } from '../../classess/type/type';

import { GlobalFormats } from '../../classess/main/globalFormats';

import TypeAddEditDetails from './TypeAddEditDetails';
import {
    awaitDelayAsync, getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, LoadingSection
} from '../../helpers/main';
import { TypeService } from '../../services/types/TypeService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { html, colors, icons, images, labels, messages, } = settings;

const currentMethod = 'Type';

export default function Types({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtTypeId = 'dtType';
    const isMount = useRef(true);
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        add: false,
    });
    const [type, setType] = useState(Type.class({}, false));
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageId: languageObj?.id,
        dtTypeId: dtTypeId,
        dtTypeRowId: 0,
    });
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        },
        spiners: {
            addEditDetails: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion methods

    //#region methods
    //#region type
    const getAddType = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getAddType';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({
                ...prev,
                showLoading: true,
                add: true,
            }));

            setType(Type.class({}, false));
            await awaitDelayAsync({ delayTime: settings?.timers?.twoNanoSeconds });

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 0,
                auth: auth,
                showModal: true,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
                add: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getEditDetailsType = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getEditDetailsType';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({
                ...prev,
                showLoading: true,
            }));

            response = await TypeService.getById({
                auth,
                id,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const typeData = !isUndNullEmp({ data: response?.result?.type, subMethod: currentMethod })?.result &&
                !isUndNull({ data: response?.result?.type?.id, subMethod: currentMethod })?.result &&
                response?.result?.type?.id > 0 ?
                Type.class(response?.result.type, false) :
                null;

            if (isUndNullEmp({ data: typeData, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>`;
                return;
            }

            setType(Type.class(typeData, false));

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 1,
                auth: auth,
                showModal: true,
                dtTypeRowId: rowId,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteType = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteType';
        try {
            e?.preventDefault?.();

            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.type?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        preConfirmResponse = await TypeService.deleteAsync({
                            auth,
                            id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        });

                        if (preConfirmResponse?.isSuccess && !preConfirmResponse?.isWarning) {
                            preConfirmResponse.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
                        }
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire({ ...swalProperties });

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
                if (!response?.isSuccess || response?.isWarning) return;
                $(`#${dtTypeId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion type
    //#endregion type

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                // Initialize DataTable
                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                // Set up event listeners
                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                // Fetch data
                response = await TypeService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const types = response?.result?.types || [];

                // Populate DataTable
                if (types.length > 0) {
                    response = setDataInDataTable({
                        data: types,
                        subMethod: currentMethod
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtTypeId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.name?.[languageObj?.id], width: '95%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtTypeId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region process
            $(`#${dtTypeId} tbody`).on('click', 'tr', 'td', async function (e) {
                try {
                    const rowId = getDtRowIndex({ dtId: dtTypeId, _this: this, subMethod: currentMethod })?.result;
                    if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                        const methodName = e?.target?.attributes?.method?.value || '';
                        const id_ = e?.target?.attributes?.id?.value || '';
                        const description = e?.target?.attributes?.description?.value || '';

                        switch (methodName) {
                            case 'edit':
                                getEditDetailsType({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                                break;
                            case 'details':
                                break;
                            case 'delete':
                                deleteType({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                                break;
                            default:
                                break;
                        }
                    }
                } catch (ex) {
                    response = getResponse({ type: -1 });
                    response.msgText = `Method: ${currentMethod}<br/>`;
                    if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                        response.msgText += `Sub method: ${subMethod}<br/>`;
                    }
                    response.msgText += `Error: ${ex?.message}<br/>`;
                } finally {
                    if (!isMount?.current) return;

                    // CSN:
                    if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                        await handleResponseMessageAsync({
                            response,
                            currentMethod,
                            auth,
                            languageId: languageObj?.id
                        });
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            const typeDt = [];

            //#region process
            data.forEach((type) => {
                const modelType = Type.class(type, false);
                const processButtons = [];
                typeDt.push([
                    modelType.name,
                    getProcessButtons({
                        id: modelType.id,
                        description: modelType.name,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtTypeId}`)?.DataTable()?.rows?.add(typeDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.settings?.settings} process={settings?.app?.views?.types?.types} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.types?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.types?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.types?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.types} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.types?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            type='button'
                                                            disabled={process?.showLoading}
                                                            className={controls?.buttons?.addEditDetails?.defaultClass}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            onClick={(e) => getAddType({
                                                                e: e,
                                                                subMethod: controls?.buttons?.addEditDetails?.id
                                                            })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {!process?.add ? (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={controls?.icons?.addEditDetails?.defaultClass} />
                                                            ) : (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtTypeId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                < TypeAddEditDetails modalObj={modalObj}
                    setModalObj={setModalObj}
                    type={type}
                    setType={setType} />
            )}
        </div>
    )
}